import script from "./EstimateDocumentHeader.vue?vue&type=script&setup=true&lang=js"
export * from "./EstimateDocumentHeader.vue?vue&type=script&setup=true&lang=js"

import "./EstimateDocumentHeader.vue?vue&type=style&index=0&id=77ccb01b&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-77ccb01b"]])

export default __exports__